import React from 'react';
import { motion } from 'framer-motion';
import './About.css';

const About = () => {
  const sectionVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  return (
    <motion.section
      id="about"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={sectionVariants}
    >
      <h2>About Me</h2>
      <p>
        I'm a 18-year-old developer with over 5 years of experience in Roblox Luau scripting.
        I'm also proficient in a variety of other languages including Python, JavaScript (Node.js), C#, and web development (HTML, CSS).
        My workflow is centered around using Rojo and Git for efficient and collaborative development.
      </p>

    </motion.section>
  );
};

export default About;
